import CoreLayout from "@layouts/core/CoreLayout";
import { useState, ReactNode } from "react";
import useUser from "@modules/user/hooks/useUser";
import LoginFlowWrapper from "@common/components/LoginFlowWrapper";
import { LoginModalMode, loginMode } from "@modules/user/types/LoginModalMode";
import WarrantyResumePurchaseMobileFloater from "@modules/purchase/warranty/components/WarrantyResumePurchaseMobileFloater";
import NavBar from "./NavBar";
import Footer from "./Footer";
import RoadwiseNavBar from "./RoadwiseNavBar";
import RoadwiseFooter from "./RoadwiseFooter";

type Props = {
  children: ReactNode[] | ReactNode;
  onLogin?: () => void;
  consumerFinancingEnabled?: boolean;
};

const PublicLayout = ({
  children,
  onLogin,
  consumerFinancingEnabled,
}: Props) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { user } = useUser();

  const [loginModalMode, setLoginModalMode] =
    useState<LoginModalMode>(loginMode);

  return (
    <CoreLayout>
      <LoginFlowWrapper
        isLoginModalOpen={showLoginModal}
        onLoginModalClose={() => setShowLoginModal(false)}
        onLogin={onLogin}
        loginModalMode={loginModalMode}
      >
        {consumerFinancingEnabled ? (
          <RoadwiseNavBar
            user={user}
            setShowLoginModal={setShowLoginModal}
            setLoginModalMode={setLoginModalMode}
          />
        ) : (
          <NavBar
            user={user}
            setShowLoginModal={setShowLoginModal}
            setLoginModalMode={setLoginModalMode}
            showResumePurchase
          />
        )}
        <div className="flex min-h-screen flex-col">{children}</div>
        <WarrantyResumePurchaseMobileFloater showResumePurchase />
        {consumerFinancingEnabled ? <RoadwiseFooter /> : <Footer />}
      </LoginFlowWrapper>
    </CoreLayout>
  );
};

export default PublicLayout;
